"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcScrollableDialog = void 0;
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcButton_1 = require("../button/AcButton");
var AcScrollableDialog = function (props) {
    var show = props.show, showCancel = props.showCancel, handleCancel = props.handleCancel, handleConfirm = props.handleConfirm, title = props.title;
    // @ts-ignore
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: show, onHide: handleCancel, "aria-labelledby": "contained-modal-title-vcenter", centered: true, scrollable: true },
        title && (react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, { id: "contained-modal-title-vcenter" }, title))),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null, props.children),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement("div", { className: "d-flex w-100" },
                showCancel && (react_1.default.createElement(AcButton_1.AcButton, { variant: "outline-primary", onClick: handleCancel, className: "border-light px-6 py-4" }, "\u30AD\u30E3\u30F3\u30BB\u30EB")),
                react_1.default.createElement("div", { className: "flex-grow-1" }),
                react_1.default.createElement(AcButton_1.AcButton, { className: "px-6 py-4", onClick: handleConfirm }, "\u8FFD\u52A0")))));
};
exports.AcScrollableDialog = AcScrollableDialog;
AcScrollableDialog.displayName = 'AcScrollableDialog';
//# sourceMappingURL=AcScrollableDialog.js.map